module.exports = __webpack_public_path__ + "media/images/buriel-3-7a03876b02346b93d61a784e60469348.png";